import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyLabor = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/labors',

        branches: [],
        branchesLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,
    },
};
